export default "__VITE_ASSET__B$cUVsP9__"